const configs = [
	{
		host: 'bonusplan24.de',
		apiUrl: '//api.thunderchild.es/',
		apiKey: 'bonusplan24-de',
		locale: 'de-DE',
		currency: 'EUR',
		title: 'Bonusplan24',
		favicon: 'https://cdn.thunderchild.es/bonusplan24-de/favicon.ico',
		googleAnalyticsId: 'UA-121335242-1'
	}
]

const config = configs.find(config => config.host === window.location.hostname)

export default config || {
	host: 'localhost',
	apiUrl: 'https://api.thunderchild.es/',
	apiKey: 'bonusplan24-de',
	locale: 'de-DE',
	currency: 'EUR',
	title: 'Bonusplan24',
	favicon: 'https://cdn.thunderchild.es/bonusplan24-de/favicon.ico'
}



// WEBPACK FOOTER //
// ./src/utils/config.js